import { FC } from 'react'
import { CSS } from '@dnd-kit/utilities'
import { Control } from 'react-hook-form'
import { cn, Button } from '@wellesley/ui'
import { PollCreate } from '@wellesley/openapi'
import { useSortable } from '@dnd-kit/sortable'
import { GripVertical, Trash } from 'lucide-react'

import CommonFormField from '../../../../form/CommonFormField'

type PollItemRowProps = {
  name: string
  value: string
  control: Control<PollCreate>
  placeholder: string
  disabledDeleteButton: boolean
  onRemove: () => void
  onChange: (value: string) => void
}

const PollItemRow: FC<PollItemRowProps> = ({
  name,
  value,
  control,
  placeholder,
  disabledDeleteButton,
  onChange,
  onRemove,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: value })

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    ...(isDragging && {
      zIndex: 10,
    }),
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="gap-xxs mb-xxs flex items-center"
    >
      <CommonFormField
        autoFocus
        name={name as keyof PollCreate}
        control={control}
        placeholder={placeholder}
        onFieldChange={(str: string) => onChange(str)}
        onAddEmoji={(text, field) => field?.onChange(text)}
        maxChars={120}
        className={cn(
          'rounded-m flex-1 border-gray-300',
          isDragging && 'bg-gray-50 shadow-md',
        )}
        icon={
          <div ref={setActivatorNodeRef} {...attributes} {...listeners}>
            <GripVertical size={20} color="var(--gray-300)" />
          </div>
        }
      />
      <Button
        variant="none"
        size="icon_xs"
        className={
          disabledDeleteButton ? 'cursor-not-allowed' : 'cursor-pointer'
        }
        onClick={disabledDeleteButton ? undefined : onRemove}
      >
        <Trash
          size={24}
          color={disabledDeleteButton ? 'var(--gray-400)' : 'var(--red-500)'}
        />
      </Button>
    </div>
  )
}

export default PollItemRow
